'use strict';

angular.module('mean.bids').factory('bidProposalPrintService', ['$filter',
    function($filter) {

        var buildTableBody = function(data, columns) {
            var body = [];

            body.push(columns);
            var final_total = 0;
            _.each(data, function(row) {
                var dataRow = [];

                _.each(columns, function(column) {
                    if(column === 'bid_total') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'bid_total_labor'){
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'bid_total_materials') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'bid_total_equipment') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'bid_overhead_and_profit') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'bid_general_liability') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else {
                        if(row[column])
                          dataRow.push(row[column].toString());
                        else
                          dataRow.push('');
                    }
                })

                final_total += row['total'];
                body.push(dataRow);
            });

            //change the labels
            _.each(body[0], function(label, idx) {
                if(label == 'item') {
                    body[0][idx] = "Plan";
                } else if(label == 'bid_total') {
                    body[0][idx] = "Total";
                } else if(label == 'bid_total_labor') {
                    body[0][idx] = "Labor";
                } else if(label == 'bid_total_materials') {
                    body[0][idx] = "Material";
                } else if(label == 'bid_total_equipment') {
                    body[0][idx] = "Equipment";
                } else if(label == 'bid_overhead_and_profit') {
                    body[0][idx] = "Overhead";
                } else if(label == 'bid_general_liability') {
                    body[0][idx] = "Gen Lib";
                } else if(label == 'quantity') {
                    body[0][idx] = "Qty";
                } 
            });

            var empty_row = []
            var ln = body[0].length;
            for(var i=0; i<ln; i++)
                empty_row.push("");
            body.push(empty_row);
            
            ln = body[0].length-2;
            var total_row = [];
            for(var i=0; i<ln; i++)
                total_row.push("");
            
            total_row.push({text:"Total: ", bold: true});
            total_row.push({
                text:'$ ' + final_total.toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                bold: true
            });
            body.push(total_row)

            return body;
        };

        var buildTaskTableBody = function(data, columns) {
            var body = [];

            body.push(columns);

            var tasks = [];
            _.each(data[0].bid_tasks, function(task) {
                tasks.push(task.name);
            });

            var final_total = 0;
            _.each(tasks, function(row) {
                var dataRow = [];
                dataRow.push(row);
                _.each(data, function(cost) {
                    var item = $filter('filter')(cost.bid_tasks, {'name': row}, true);

                    if(item.length == 1) {
                        dataRow.push('$ ' + item[0].total.toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    }
                });
                body.push(dataRow);
            });

            var empty_row = []
            var ln = body[0].length;
            for(var i=0; i<ln; i++)
                empty_row.push("");
            body.push(empty_row);
            
            ln = body[0].length-2;
            var total_row = [];
            for(var i=0; i<ln; i++)
                total_row.push("");
            
            total_row.push({text:"Total: ", bold: true});
            total_row.push({
                text:'$ ' + final_total.toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                bold: true
            });
            body.push(total_row)

            return body;
        };

        var buildTable = function(data, columns) {
            //use the * widths with blank text to center the table on the page
            return {
                columns: [{
                    width: '*', text: ''
                }, {
                    table: {
                        headerRows: 1,
                        body: buildTableBody(data, columns)
                    },
                    width: 'auto',
                    fontSize: 10,
                    layout: 'headerLineOnly'
                }, {
                    width: '*', text: ''
                }]
            }
        };

        var buildTaskTable = function(data, columns) {
            //use the * widths with blank text to center the table on the page
            return {
                columns: [{
                    width: '*', text: ''
                }, {
                    table: {
                        headerRows: 1,
                        body: buildTaskTableBody(data, columns)
                    },
                    width: 'auto',
                    fontSize: 10,
                    layout: 'headerLineOnly'
                }, {
                    width: '*', text: ''
                }]
            }
        };

        var buildPDF = function(bid, trade_bid, trade, plans, user, show_vars) {
            var pdf_header = "";
            var pdf_owner = "";
            var pdf_contractor = "";
            var pdf_proposal = "";
            var pdf_cost = "";
            var pdf_terms = "";
            var pdf_inclusions = "";
            var pdf_exclusions = "";
            var pdf_signature = "";
            var pdf_page_break = "";

            if(show_vars.showHeaderInfo) {
                if(trade.logo_one) {
                    pdf_header = [{
                        columns : [{
                            text : trade_bid.form_title,
                            margin : [ 10,18,0,0 ],
                            style: 'header',
                            width : 300,
                        }, {
                            width: '*',
                            text: '',
                        }, {
                            image: trade.logo_one,
                            width: 160,
                            height: 50,
                        }],
                        columnGap: 10
                    }, {
                        canvas: [{
                            type: 'line',
                            x1: 10,
                            y1: 0,
                            x2: 595-10,
                            y2: 0,
                            lineWidth: 0.5
                        }]
                    }]
                } else {
                    pdf_header = [{
                        columns : [{
                            text : trade_bid.form_title,
                            margin : [ 10,18,0,0 ],
                            style: 'header',
                            width : 300,
                        }, {
                            width: '*',
                            text: '',
                        }],
                        columnGap: 10
                    }, {
                        canvas: [{
                            type: 'line',
                            x1: 10,
                            y1: 0,
                            x2: 595-10,
                            y2: 0,
                            lineWidth: 0.5
                        }]
                    }]
                }
            }

            if(show_vars.showPageBreak) {
                pdf_page_break = [{ 
                    text: '', 
                    fontSize: 8, 
                    pageBreak: 'before', 
                    margin: [0, 0, 0, 8] 
                }]
            }

            if(show_vars.showOwnerInfo) {
                pdf_owner = [
                    {
                        text: trade_bid.client_info_title, 
                        style: 'header2a'
                    },
                    {
                        stack: [{
                            layout: {
                                hLineWidth: function hLineWidth(i) {return 0;},
                                vLineWidth: function vLineWidth(i) { return 0;},
                                paddingLeft: function(i, node) { return 0; },
                                paddingRight: function(i, node) { return 0; },
                                paddingTop: function(i, node) { return 0; },
                                paddingBottom: function(i, node) { return 0; }
                            },
                            table: {
                                headerRows: 0,
                                widths: [80, '*'],
                                body: [
                                    ['Name: ', bid.builder_info.name],
                                    ['Address: ', bid.builder_info.address_one + ' ' + bid.builder_info.address_two],
                                    ['City, State, ZIP: ', bid.builder_info.city + ', ' + bid.builder_info.state + ' ' + bid.builder_info.zip],
                                    ['Phone: ', bid.builder_info.phone],
                                    ['Email: ', bid.builder_info.email],
                                    ['Project Name: ', bid.project_name],
                                ]
                            }
                        }]
                    }
                ]
            }

            if(show_vars.showContractorInfo) {
                pdf_contractor = [
                    {
                        text: trade_bid.contractor_info_title, 
                        style: 'header2a'
                    },
                    {
                        stack: [{
                            layout: {
                                hLineWidth: function hLineWidth(i) {return 0;},
                                vLineWidth: function vLineWidth(i) { return 0;},
                                paddingLeft: function(i, node) { return 0; },
                                paddingRight: function(i, node) { return 0; },
                                paddingTop: function(i, node) { return 0; },
                                paddingBottom: function(i, node) { return 0; }
                            },
                            table: {
                                headerRows: 0,
                                widths: [80, '*'],
                                body: [
                                    ['Name: ', trade.name],
                                    ['Address: ', trade.address_one + ' ' + trade.address_two],
                                    ['City, State, ZIP: ', trade.city + ', ' + trade.state + ' ' + trade.zip],
                                    ['Phone: ', trade.phone],
                                    ['Email: ', trade.email],
                                    ['Start Date: ', new moment(bid.project_start_date).format('MMM D, YYYY')],
                                ]
                            }
                        }]
                    }
                ]
            }

            if(show_vars.showProposalInfo) {
                var prop_text = "";

                trade_bid.proposals.forEach(function(prop) {
                    prop_text += prop + '\n';
                });
                pdf_proposal = {
                    stack: [{
                        text: trade_bid.proposal_title, 
                        style: 'header2',
                    },
                    {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, {
                        text: prop_text,
                        fontSize: 10,
                        style: "lineSpacing",
                        margin: [0,0,0,10]
                    }]
                }
            }

            if(show_vars.showCostInfo) {
                if(show_vars.selectionOption == 'plan_detail') {
                    pdf_cost = {
                        stack: [{
                            text: trade_bid.cost_breakdown_title, 
                            style: 'header2'
                        }, {
                            canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                            style: "lineSpacing"
                        },
                        buildTable(plans, ['item', 'quantity', 'bid_total', 'bid_total_labor', 'bid_total_materials', 
                            'bid_total_equipment', 'bid_overhead_and_profit', 'bid_general_liability']),
                        ]
                    }
                } else if(show_vars.selectionOption == 'plan') {
                    pdf_cost = {
                        stack: [{
                            text: trade_bid.cost_breakdown_title, 
                            style: 'header2',
                        }, {
                            canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                            style: "lineSpacing"
                        },
                        buildTable(plans, ['item', 'quantity', 'bid_total'])
                        ]
                    }
                } else if(show_vars.selectionOption == 'task') {
                    var plan_list = [];
                    plan_list.push("Task");
                    for(var i=0; i<plans.length; i++) {
                        plan_list.push(plans[i].item);
                    }

                    pdf_cost = {
                        stack: [{
                            text: trade_bid.cost_breakdown_title, 
                            style: 'header2',
                        }, {
                            canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                            style: "lineSpacing"
                        },
                        buildTaskTable(plans, plan_list)
                        ]
                    }
                } 
            }

            if(show_vars.showTermsInfo) {
                pdf_terms = {
                    stack: [{
                        text: trade_bid.terms_title, 
                        style: 'header2',
                    },
                    {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, {
                        text: trade_bid.terms,
                        fontSize: 10,
                        style: "lineSpacing",
                        margin: [0,0,0,10]
                    }]
                }
            }

            if(show_vars.showInclusionsInfo) {
                var in_array = angular.copy(trade_bid.inclusions);
                pdf_inclusions = {
                    stack: [{
                        text: trade_bid.inclusions_title, 
                        style: 'header2',
                    },
                    {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, {
                        ul: in_array,
                        fontSize: 10,
                        style: "lineSpacing",
                        margin: [0,0,0,10]
                    }]
                }
            }

            if(show_vars.showExclusionsInfo) {
                var ex_array = angular.copy(trade_bid.exclusions);
                pdf_exclusions = {
                    stack: [{
                        text: trade_bid.exclusions_title, 
                        style: 'header2',
                    },
                    {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, {
                        ul: ex_array,
                        fontSize: 10,
                        style: "lineSpacing",
                        margin: [0,0,0,10]
                    }]
                }
            }

            if(show_vars.showSignatureInfo) {
                pdf_signature = {
                    stack: [{
                        canvas: [{ 
                            type: 'line', 
                            x1: 0, y1: 5, 
                            x2: 300, y2: 5, 
                            lineWidth: 0.5 
                        }, {
                            type: 'line', 
                            x1: 350, y1: 5, 
                            x2: 595-20, y2: 5, 
                            lineWidth: 0.5,
                        }],
                        margin : [ 0,20,0,0 ],
                    }, {
                        layout: 'noBorders',
                        table: {
                            headerRows: 0,
                            widths: [345, '*'],
                            body: [
                                [{ text: 'Submitted by ' + user.name }, {text: 'Date signed'}],
                            ]
                        },
                        margin : [ 0,0,0,6 ],
                    },
                    {
                        text: trade_bid.acceptance_title, 
                        style: 'header2',
                    },
                    {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, {
                        text: trade_bid.acceptance_text,
                        fontSize: 10,
                        style: "lineSpacing"
                    }, {
                        canvas: [{ 
                            type: 'line', 
                            x1: 0, y1: 5, 
                            x2: 300, y2: 5, 
                            lineWidth: 0.5 
                        }, {
                            type: 'line', 
                            x1: 350, y1: 5, 
                            x2: 595-20, y2: 5, 
                            lineWidth: 0.5,
                        }],
                        margin : [ 0,25,0,0 ],
                    }, {
                        layout: 'noBorders',
                        table: {
                            headerRows: 0,
                            widths: [345, '*'],
                            body: [
                                [{ text: trade_bid.signed_by }, {text: 'Date signed'}],
                            ]
                        }
                    }]
                }
            }

            var pdf_contacts = {
                fontSize: 10,
                columns: [
                    pdf_owner,
                    pdf_contractor
                ],
                margin : [ 0,0,0,10 ],
            }

            // var pdf_footer = [{
            //     canvas: [{
            //         type: 'line',
            //         x1: 10,
            //         y1: 0,
            //         x2: 595-10,
            //         y2: 0,
            //         lineWidth: 0.5
            //     }]
            // }, {
            //     columns : [{
            //         text : trade_bid.form_title,
            //         margin : [ 10,0,0,0 ],
            //         width : 300,
            //     }, {
            //         width: '*',
            //         text: '',
            //     }, {
            //         function(currentPage, pageCount) { 
            //             return currentPage.toString() + ' of ' + pageCount; 
            //         }
            //     }],
            //     columnGap: 10
            // }]

            var print_sections = [];
            trade_bid.sections.forEach(function(section) {
                if(section.label == 'Contact Information') {
                    print_sections.push(pdf_contacts);
                } else if(section.label == 'Proposal') {
                    print_sections.push(pdf_proposal);
                } else if(section.label == 'Terms & Conditions') {
                    print_sections.push(pdf_terms);
                } else if(section.label == 'Cost Breakdown') {
                    print_sections.push(pdf_cost);
                } else if(section.label == 'Inclusions') {
                    print_sections.push(pdf_inclusions);
                } else if(section.label == 'Exclusions') {
                    print_sections.push(pdf_exclusions);
                } else if(section.label == 'Owner Acceptance') {
                    print_sections.push(pdf_signature);
                } else if(section.label == 'Page Break') {
                    print_sections.push(pdf_page_break);
                }
            })


            console.log('printing...');
            var test = {
                styles: {
                    header: {
                        fontSize: 22,
                        bold: true,
                    },
                    header2: {
                        fontSize: 15,
                        margin:[0,0,0,-4],
                        bold: true,
                    },
                    header2a: {
                        fontSize: 15,
                        margin:[0,0,0,-2],
                        bold: true
                    },
                    anotherStyle: {
                        italics: true,
                        alignment: 'right'
                    },
                    squeezeSpacing: {
                        margin:[0,0,0,0]
                    },
                    lineSpacing: {
                        margin:[0,0,0,6] //change number 6 to increase nspace
                    }
                },
                pageMargins: [ 10, 65, 10, 20 ],
                pageSize: 'A4',
                Roboto: {
                    normal: 'Roboto-Regular.ttf',
                    bold: 'Roboto-Medium.ttf',
                    italics: 'Roboto-Italic.ttf',
                    bolditalics: 'Roboto-Italic.ttf'
                },
                header: pdf_header,
                content: print_sections,
                footer: function(currentPage, pageCount) {
                    return {
                        margin: [10, 0, 10, 0],
                        height: 30,
                        columns: [{
                            text : 'Bid Proposal for ' + bid.project_name,
                            width : 300,
                            //margin: [10,0,0,0]
                        }, {
                            width: '*',
                            text: '',
                        }, {
                            text: currentPage.toString() + ' of ' + pageCount,
                            alignment: 'right',
                            //margin: [0,0,10,0]
                        }]
                    }
                },
                defaultStyle: {
                    font: 'Roboto'
                }
            }

            // var taskCode = $scope.selectedReport.task_code;
            // var devDate = new moment($scope.selectedReport.delivery_date).format('MMM D, YYYY : HH:mm')

            // var fileName = $scope.trade.name + '-' + $scope.selectedProject.name + '-' + $scope.selectedPhase.name +
            //         '-' + taskCode + '-' + rpt_num + '-PhaseReport.pdf';

            // if($scope.just_print) {
                pdfMake.createPdf(test).open();
                // $scope.just_print = false;

                // if($scope.print_as_foreman) {
                //     $scope.print_as_foreman = false;
                //     $scope.is_foreman = false;
                // }
            // } else {
            //     console.log('invoice submitted?', $scope.selectedReport);
            //     var projectInfo = angular.copy($scope.selectedReport);
            //     pdfMake.createPdf(test).getBase64(function(buffer) {
            //         var data = ({
            //             to: $scope.email_contacts,
            //             subject: $scope.trade.name + ' Order (' + po_num + ')',
            //             message: 'Attached is an order from ' + $scope.trade.name + '<br>' +
            //                 '<strong>Delivery date is scheduled for ' + devDate +
            //                 '</strong> <br><br>' +
            //                 'Delivery is to Job Address <br>' +
            //                 $scope.selectedProject.contact.address_one + '<br>' +
            //                 $scope.selectedProject.contact.city + ', ' + $scope.selectedProject.contact.state + ' ' +
            //                 $scope.selectedProject.contact.zip +
            //                 '<br><br><br>This report is created using .A.C.E. Construction Software.<br>' +
            //                 'Please do not reply to this email and contact the contractor if you have any questions.',
            //             fileName: fileName,
            //             attachment: buffer
            //         });

            //         $http.post('/api/sendPhaseReports', data).
            //           success(function(data, status, headers, config) {
            //             console.log('Message was successfully sent');
            //           }).
            //           error(function(data, status, headers, config) {
            //             console.log('There was an error with the message');
            //         });

            //         // save to invoice into document
            //         var projectData = {
            //             phase: projectInfo.phase,
            //             project_id: projectInfo.project_id._id || projectInfo.project_id
            //         };
            //         projectData.fileName = po_num + '.pdf';
            //         projectData.folderTitle = 'Material & Equipment';
            //         projectData.uploadedBy = $scope.user.username;
            //         projectData.attachment = buffer;
            //         projectData.mainAccountId = $scope.main_account._id;
            //         $http.post('/api/materialReport', projectData).
            //           success(function(data, status, headers, config) {
            //             console.log('Report uploaded successfully');
            //           }).
            //           error(function(data, status, headers, config) {
            //             console.log('There was an error with the message');
            //         });
            //     });
            // }
        };

        return {
            buildPDF: buildPDF,
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/bids/public/services/bid-proposal-print-service.js